import React, { useEffect, useState } from 'react';
import { RoughNotation } from 'react-rough-notation';
import { StaticImage } from 'gatsby-plugin-image';
import { graphql } from 'gatsby';
import Cookies from 'js-cookie';
/* --- import Components ----*/
import { Section, TwoColumns } from '../components/Section';
import { AdmissionProcess } from 'src/components/Bootcamp/AdmissionTimeline';
import { AlumniJobGrid } from '../components/Bootcamp/Testimonials/';
import { Apply } from '../components/Apply/index';
import { AnchorButton, Button, MobileApplyBTN } from 'src/components/Button';
import { BtnWrapper, HeroLeft } from 'src/components/Hero/elements';
import { Career, LearningAndTechno, Profile, QuestionCTA, WhyJS } from 'src/components/Bootcamp';
import { DiplomaSection, TASection } from '../components/Home';
import {
  HeaderDescription,
  HeaderTitle,
  Paragraph,
  SectionTitle,
  StyledLink,
  StyledSmoothAnchorLink,
} from 'src/components/Typography';
import { BestBootcamp } from 'src/components/Home';
import BootcampTypeBanner from 'src/components/Bootcamp/BootcampTypeBanner/BootcampTypeBanner.js';
import { CTASection } from '../components/CTA';
import { EventsSection } from '../components/MeetUs/index';
import { GoogleReviews } from 'src/components/GoogleReview';
import { HeaderBanner } from '../components/Section/index';
import Layout from '../components/Layout';
import ModalForm from 'src/components/Modal/ModalFormSyllabus';
import Opportunities from '../components/Bootcamp/Opportunities/Opportunities';
import { ProjectsOverview } from 'src/components/Projects';
import { Schedule } from '../components/Bootcamp/Schedule/index';
import Tag from 'src/components/Tags/Tag';
import { TagContainer } from 'src/components/Tags/elements';
import { TopbarStaticSpace } from '../components/Topbar';
import TopbarWithSubBar from 'src/components/Topbar/TopbarWithSubBar';
import FeaturesSection from 'src/components/Bootcamp/FeaturesSection';
import TopBanner from 'src/components/TopBanner';
/* --- import Utils ----*/
import { SessionDateDisplay, nextSessionsFilter } from 'src/utils/helpers';
/* --- import Styles ----*/
import { mediaQueries } from 'src/style/breakpoints';
import sizes from 'src/style/sizes';
import colors from 'src/style/colors';

const bootcampType = 'Temps Partiel';

const HalfTimePage = ({ location, pageContext: { nextSessions, dataFromMeetup } }) => {
  const [buttonVisible, setButtonVisible] = useState(false);
  const [sectionScrolled, setSectionScrolled] = useState(null);
  const [isModalFormOpen, setIsModalFormOpen] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [values, setValues] = useState();
  const [isBannerClosed, setIsBannerClose] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (global.window && window.pageYOffset >= 150) {
        return setButtonVisible(true);
      } else {
        return setButtonVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [buttonVisible]);

  const container = React.useRef();

  useEffect(() => {
    const isElementVisible = () => {
      const allContainer = Array.from(container.current.children);
      let current = null;

      for (let i = 0; i < allContainer.length; i++) {
        const oneContainer = allContainer[i];
        const itemPos = oneContainer.getBoundingClientRect();
        const isVisible = itemPos.top <= 260 && itemPos.bottom >= 240;
        if (isVisible) {
          current = oneContainer;
        }
      }

      const expectedValue = current ? '#' + current.id : null;
      if (sectionScrolled !== expectedValue) {
        setSectionScrolled(expectedValue);
      }
    };
    window.addEventListener('scroll', isElementVisible);
    return () => window.removeEventListener('scroll', isElementVisible);
  }, [sectionScrolled]);

  const nextPartTimeSession = nextSessionsFilter(
    nextSessions,
    'formation-developpeur-web-mobile-temps-partiel'
  );
  const date = SessionDateDisplay(nextPartTimeSession[0], bootcampType);

  const handleNextPartTimeSessionId = () => {
    if (nextPartTimeSession) {
      const sessionId = nextPartTimeSession[0].id;
      return sessionId;
    } else {
      return null;
    }
  };

  useEffect(() => {
    if (!Cookies.get('bannerHidden')) {
      setIsBannerClose(false);
    }
  }, []);

  return (
    <Layout
      pathname={location.pathname}
      businessType="B2C"
      pageName="Bootcamp part-time"
      pageType="bootcamp"
      metaTitle="Formation développeur Web et Mobile JavaScript en cours du soir et week-end | Le Reacteur"
      metaDescription="La formation pour devenir développeur Web et Mobile chez Le Reacteur : un coding bootcamp de 6 mois à temps partiel à distance (en visio)."
      currentCoursePage={bootcampType}
      isBootcampPage
      sectionScrolled={sectionScrolled}
    >
      {isBannerClosed ? null : <TopBanner setIsBannerClose={setIsBannerClose} />}

      <TopbarWithSubBar
        currentCoursePage={bootcampType}
        sectionScrolled={sectionScrolled}
        isBannerClosed={isBannerClosed}
      />
      <Section
        theme="primary"
        hero={true}
        css={{
          [mediaQueries.desktopUp]: {
            height: '100vh',
            minHeight: '820px',
            maxHeight: '1000px',
          },
        }}
      >
        <TopbarStaticSpace />
        <div
          css={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            [mediaQueries.desktopUp]: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '-110px',
            },
          }}
        >
          <HeroLeft css={{ flex: 1 }} data-cy="heroLeft">
            <HeaderTitle>
              Formation Développeur{' '}
              <br
                css={{
                  display: 'none',
                  [mediaQueries.tabletPortraitUp]: {
                    display: 'block',
                  },
                  [mediaQueries.phoneOnly]: {
                    display: 'block',
                  },
                  // [mediaQueries.desktopUp]: {
                  //   display: 'none',
                  // },
                }}
              />
              Web et Mobile{' '}
            </HeaderTitle>
            <TagContainer>
              <Tag hero color="purpleDark" spacer>
                Web+Mobile
              </Tag>
              <Tag color="yellow" hero spacer>
                diplômant Bac+3/4
              </Tag>
              <Tag type="online" hero />
            </TagContainer>
            <HeaderDescription
              css={{
                marginTop: 30,
                textAlign: 'center',
                [mediaQueries.desktopUp]: {
                  marginRight: 60,
                  textAlign: 'left',
                },
              }}
            >
              Un format à temps partiel de 6 mois, le mardi et le jeudi soir ainsi que la journée du
              samedi, pour apprendre le métier de Développeur Web et Mobile.
            </HeaderDescription>
            <HeaderDescription
              css={{
                color: colors.yellow,
                fontWeight: 'bold',
                marginTop: 8,
              }}
            >
              Prochaine session :{' '}
              <br
                css={{
                  [mediaQueries.tabletPortraitUp]: {
                    display: 'none',
                  },
                }}
              />{' '}
              {date}
            </HeaderDescription>
            <BtnWrapper data-cy="apply-btn1">
              <AnchorButton
                className="apply-btn"
                to="/postuler"
                state={{
                  fromFormationsPage: {
                    certification: 'RNCP6',
                    type: bootcampType,
                    date: handleNextPartTimeSessionId(),
                  },
                }}
                css={{
                  marginRight: 16,
                  [mediaQueries.phoneOnly]: {
                    marginRight: 0,
                    marginBottom: '20px',
                    width: '100%',
                  },
                }}
              >
                Postuler
              </AnchorButton>
              <Button
                secondary
                css={{
                  minWidth: 210,
                }}
                onClick={() => {
                  setIsModalFormOpen(!isModalFormOpen);
                }}
              >
                Recevoir{' '}
                <br
                  css={{
                    [mediaQueries.tabletPortraitUp]: {
                      display: 'none',
                    },
                  }}
                />{' '}
                le programme de formation
              </Button>
            </BtnWrapper>

            {isModalFormOpen && (
              <>
                <ModalForm
                  isOpen={isModalFormOpen}
                  onClose={() => {
                    setFormSuccess(false);
                    setIsModalFormOpen(false);
                  }}
                  fromFormationsPageType={bootcampType}
                  formSuccess={formSuccess}
                  setFormSuccess={setFormSuccess}
                  values={values}
                  setValues={setValues}
                />
              </>
            )}
          </HeroLeft>
          <StaticImage
            src="../../src/data/images/2023_students5.jpg"
            alt="Formation Développeur Web et Mobile : un élève"
            css={{
              display: 'flex',
              flex: 1,
              [mediaQueries.phoneOnly]: {
                marginTop: 40,
              },
              [mediaQueries.tabletPortraitUp]: {
                marginTop: 100,
              },
              [mediaQueries.tabletLandscapeUp]: {
                marginTop: 100,
              },
              [mediaQueries.desktopUp]: {
                marginTop: '0',
              },
            }}
            imgStyle={{
              borderRadius: 5,
              boxShadow: '5px 25px 40px rgba(0, 0, 0, 0.2)',
              objectFit: 'cover',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
        </div>
      </Section>
      <HeaderBanner theme="secondary">
        <Profile defaultIndex={0} fromFormationsPageType={bootcampType} />
      </HeaderBanner>

      {/* UN CODING BOOTCAMP */}
      <Section theme="secondary">
        <div css={{ paddingBottom: 0 }}>
          <TwoColumns
            center
            reverse
            sizeLeft={sizes.columnWidth.medium}
            right={
              <div css={{ flex: 1 }}>
                <SectionTitle>Un Coding Bootcamp ?</SectionTitle>
                <Paragraph
                  css={{
                    paddingTop: 30,
                    [mediaQueries.tabletPortraitUp]: {
                      paddingBottom: 0,
                    },
                  }}
                >
                  Que vous soyez actuellement&nbsp;salarié·e ou en{' '}
                  <StyledLink to="/blog/2020-01-27-reconversion-professionnelle-tout-quitter-pour-devenir-developpeur/">
                    reconversion professionnelle
                  </StyledLink>
                  , nous avons décliné notre bootcamp sous 3 formats.
                  <br />
                  <br />
                  <StyledLink to="/bootcamp-javascript/formation-developpeur-web-mobile/">
                    À temps plein
                  </StyledLink>{' '}
                  pendant 10 semaines,{' '}
                  <StyledLink to="/bootcamp-javascript/formation-developpeur-web-mobile-temps-partiel/">
                    à temps partiel
                  </StyledLink>{' '}
                  pendant 6 mois ou{' '}
                  <StyledLink to="/formation-alternance/concepteur-developpeur-applications/">
                    en alternance
                  </StyledLink>{' '}
                  pendant 15 à 17 mois, vous pouvez désormais vous reconvertir professionnellement
                  selon vos disponibilités.
                  <br />
                  <br />
                  Le bootcamp à temps plein est dispensé en <strong>présentiel</strong> (dans nos
                  locaux) ou en <strong>téléprésentiel</strong> (en visio), pour s'adapter à la
                  localisation et/ou aux contraintes de mobilité (handicap, par ex.) de tous nos
                  élèves.
                  <br />
                  <br />
                  Si vous souhaitez en savoir plus sur notre bootcamp, n'hésitez pas à vous inscrire
                  à l'une de nos{' '}
                  <StyledSmoothAnchorLink offset="100" href="#event-section">
                    réunions d'information
                  </StyledSmoothAnchorLink>
                  .
                </Paragraph>
              </div>
            }
            sizeRight={sizes.columnWidth.medium}
            left={
              <StaticImage
                src="../../src/data/images/2023_students9.jpg"
                alt="Formation Développeur Web et Mobile : un élève"
                // placeholder="none"
                css={{
                  flex: 1,
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  borderRadius: 5,
                  boxShadow: '5px 25px 40px rgba(0, 0, 0, 0.2)',
                  [mediaQueries.phoneOnly]: {
                    height: '70%',
                    marginBottom: 15,
                  },
                  [mediaQueries.tabletPortraitUp]: {
                    height: '70%',
                  },
                  [mediaQueries.tabletLandscapeUp]: {
                    height: '100%',
                  },
                }}
              />
            }
          />
        </div>
      </Section>
      <BestBootcamp />
      <ProjectsOverview
        isModalFormOpen={isModalFormOpen}
        setIsModalFormOpen={setIsModalFormOpen}
        bootcampType={bootcampType}
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        values={values}
        setValues={setValues}
        hideProjects={true}
      />

      <DiplomaSection diploma="rncp6" />
      {/* <ProjectsExamples id="projets" /> */}
      <LearningAndTechno theme="secondary" id="objectives" title="Objectifs de la formation" />

      {/* ICONS SECTION */}
      <FeaturesSection fromPage="rncp6-partTime" />
      <div ref={container}>
        <Apply
          nextSessions={nextPartTimeSession}
          id="next-sessions"
          fromFormationsPageType={bootcampType}
        />
        <Schedule
          course={'rncp6-partTime'}
          isModalFormOpen={isModalFormOpen}
          setIsModalFormOpen={setIsModalFormOpen}
          bootcampType={bootcampType}
          formSuccess={formSuccess}
          setFormSuccess={setFormSuccess}
          values={values}
          setValues={setValues}
        >
          Pendant 6 mois vous apprendrez la programmation à travers{' '}
          <span css={{ position: 'relative' }}>
            <RoughNotation
              type="underline"
              multiline={true}
              strokeWidth={2}
              color={colors.yellow}
              show={true}
              padding={[0, 0, 4, 0]}
            >
              5 modules
            </RoughNotation>
          </span>{' '}
          en distanciel. Chaque module vous apportera les compétences nécessaires pour aller
          toujours plus loin.
          <br />
          <br />
          Pendant la semaine, vous assisterez aux cours pendant lesquels vous seront enseignées de
          nouvelles notions. Vous aurez également droit à une correction en live des exercices. Vous
          devrez travailler au moins{' '}
          <span css={{ position: 'relative' }}>
            <RoughNotation
              type="underline"
              multiline={true}
              strokeWidth={2}
              color={colors.yellow}
              show={true}
              padding={[0, 0, 4, 0]}
            >
              1 à 2 heures par soir
            </RoughNotation>
          </span>
          , les jours où vous n'aurez pas cours. Enfin, le samedi, vous serez aidé par votre
          formateur et ses assistants.
          <br />
          <br />
          Gwendoline et Alexis seront vos formateurs pendant toute cette période.
        </Schedule>
        <TASection training="tps-partiel" />
        <WhyJS />
        <Career training="fullAndPartTime" />
        <AlumniJobGrid />
        <Opportunities />
        <GoogleReviews course="formation-developpeur-web-mobile" />
        <AdmissionProcess
          id="admission"
          fromFormationsPage={{
            certification: 'RNCP6',
            type: bootcampType,
            date: handleNextPartTimeSessionId(),
          }}
        />
        <EventsSection id="event-section" dataFromMeetup={dataFromMeetup} />
      </div>

      <CTASection
        onBoardingPromise="24 semaines (6 mois) de code"
        course="Développeur Web et Mobile"
        nextSession={date}
        nextPartTimeSession={handleNextPartTimeSessionId()}
        numberOfWeeks="24"
        format="à&nbsp;temps partiel"
        fromFormationsPageCertification="RNCP6"
        fromFormationsPageType={bootcampType}
        formSuccess={formSuccess}
        setFormSuccess={setFormSuccess}
        values={values}
        setValues={setValues}
      />
      <BootcampTypeBanner isFullTimePage={false} />
      <QuestionCTA fromFormationsPage={bootcampType} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Course',
            name: 'Formation Développeur Web et Mobile, à temps partiel',
            description:
              'La formation pour devenir développeur Web et Mobile chez Le Reacteur : un coding bootcamp de 6 mois à temps partiel, en présentiel (à Paris) ou à distance (en visio).',
            provider: {
              name: 'Le Reacteur',
              sameAs: [
                'https://www.lereacteur.io/bootcamp-javascript/formation-developpeur-web-mobile-temps-partiel/',
              ],
            },
          }),
        }}
      />
      <MobileApplyBTN
        buttonVisible={buttonVisible}
        currentCoursePage={bootcampType}
        certification="RNCP6"
      />
    </Layout>
  );
};

export default HalfTimePage;

export const query = graphql`
  query {
    allFile(filter: { extension: { eq: "pdf" } }) {
      edges {
        node {
          name
          publicURL
        }
      }
    }
  }
`;
